import { useEffect, useState } from 'react';

/**
 * SM_009: Debounce a rapidly-changing value (e.g. a search box) so dependent
 * work — like the links list query — fires once after typing stops, not on every
 * keystroke. Returns the latest value once it has been stable for `delayMs`.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
